<template>
	<aside
		class="c-siteFavorite"
		:aria-label="translations['Site favorites']"
		:class="{ 'c-siteFavorite--open': isIndex }"
	>
		<div class="c-siteFavorite__button" @click="open">
			<FavoriteIcon></FavoriteIcon>
		</div>

		<SlideInOverlay
			:is-open="isOpen"
			placement="right"
			@close="close"
			@enter="enter"
			class="c-siteFavorite__overlay"
		>
			<template v-slot:header>
				<h2>{{ translations["Favorites"] }}</h2>
				<button
					:aria-label="translations['Close']"
					class="close"
					@click="close"
				>
					<CloseIcon></CloseIcon>
				</button>
			</template>
			<template v-slot:body>
				<FavoriteLineItem
					v-for="favorite in favorites.items"
					:key="favorite.id"
					:lineItem="favorite"
				></FavoriteLineItem>
			</template>
			<template v-slot:footer>
				<div class="button">
					<a :href="siteUrl + 'shop/favorite'">{{
						translations["See favorites"]
					}}</a>
				</div>
			</template>
		</SlideInOverlay>
	</aside>
</template>

<script>
import SlideInOverlay from "@/vue/components/objects/SlideInOverlay.vue";
import * as map from "@/vue/mixins/map";
import request from "@/vue/mixins/request.js";

// ICONS
import CloseIcon from "@web/assets/icon/close.svg";
import FavoriteIcon from "@web/assets/icon/favorite.svg";
import FavoriteLineItem from "@/vue/components/commerce/objects/FavoriteLineItem.vue";

export default {
	name: "SiteFavorite",
	mixins: [map.site, request],
	components: {
		SlideInOverlay,
		CloseIcon,
		FavoriteIcon,
		FavoriteLineItem,
	},
	data: () => {
		return {
			isOpen: false,
			isIndex: false,
		};
	},
	methods: {
		close() {
			this.isOpen = false;

			setTimeout(() => {
				this.isIndex = false;
			}, 250);
		},
		open() {
			this.isOpen = true;
			this.isIndex = true;
		},
		enter() {
			window.location.href = this.siteUrl + "shop/favorite";
		},
	},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.c-siteFavorite {
	z-index: 9;
	height: 100%;

	&__button {
		height: 100%;
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.inner {
		display: flex;
		flex-direction: column;

		&__header {
			width: 100%;
			padding-inline: 40px;
			padding-top: 40px;
			padding-bottom: 24px;

			display: flex;
			justify-content: space-between;

			h2 {
				line-height: 24px;
			}

			.close {
				cursor: pointer;
				width: 35px;
				height: 35px;

				display: flex;
				align-items: flex-start;
				justify-content: flex-end;

				svg {
					width: 16px;
					height: 16px;
				}
			}
			border-bottom: $e-border;
		}
		&__body {
			padding-inline: 40px;
		}

		&__footer {
			border-top: $e-border;
			padding-top: 24px;
			padding-bottom: 24px;
			padding-inline: 40px;
			flex-direction: column;
			display: flex;

			.button {
				display: flex;
				justify-content: center;

				a {
					font-weight: $f-semibold;
					@include hover-underline($reverse: true);
				}
			}
		}
	}

	&--open {
		z-index: 21;
	}
}

@media all and (max-width: 768px) {
	.c-siteFavorite {
		.inner {
			&__header {
				padding-inline: 30px;
			}
			&__body {
				padding-inline: 30px;
			}
			&__footer {
				padding-inline: 30px;
			}
		}
	}
}

@media all and (max-width: 450px) {
	.c-siteFavorite {
		.inner {
			&__header {
				padding-inline: $s-side;
			}
			&__body {
				padding-inline: $s-side;
			}
			&__footer {
				padding-inline: $s-side;
			}
		}
	}
}

@media all and (max-width: 360px) {
	.c-siteFavorite {
		.inner {
			&__footer {
				.total {
					p {
						line-height: 18px;
						display: flex;
						flex-direction: column;

						span {
							font-size: $font-disclaimer-size;
						}
					}
				}
			}
		}
	}
}

@keyframes rippleScale {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	100% {
		transform: scale(5);
		opacity: 0;
	}
}
</style>
